import script from "./WelcomeNav.vue?vue&type=script&async=true&setup=true&lang=js"
export * from "./WelcomeNav.vue?vue&type=script&async=true&setup=true&lang=js"

const __exports__ = script;

export default __exports__